import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sketch': {
    width: 494,
    height: 512,
    paths: [
      {
        d: 'M18.5 162.2L0 187.1H90.5L97.4 56.4 18.5 162.2zM387.3 45.7L258.7 32 394.4 179.2 387.3 45.7zM103.2 218.3L92 196.3H0.9L225.8 458 103.2 218.3zM105.2 187.1H389.2L307.7 98.6 247.3 33 105.2 187.1zM402.5 196.2L268.6 458 493.4 196.3H402.5zM406.4 69L397 56.4 397.9 73.7 404 187.1H494.3L406.4 69zM104.5 93.5L99.9 179.1 235.7 32 107.1 45.7 104.5 93.5zM392.2 196.2H102.2L144.6 279.1 247.3 480 392.2 196.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/sketch.js
// module id = bZSB
// module chunks = 144